module.exports = __webpack_public_path__ + "static/media/MTC.674ba879.png";